import { ca } from '@cian/analytics';
import { TFilter } from 'shared/types/filters';

export const QUICK_FILTERS_KEYS: TFilter[] = ['advancedFilters', 'dealType', 'offerType', 'roomType', 'price'];

export const QuickFiltersMap = {
  advancedFilters: 'main',
  dealType: 'deal_type',
  offerType: 'offer_type',
  roomType: 'rooms',
  price: 'price',
  region: 'region',
  district: 'district',
  metro: 'metro',
};

export type TQuickFilterKey = keyof typeof QuickFiltersMap;

export const trackQuickFilterClick = (filterKey: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Filters',
    action: 'click',
    label: filterKey,
    useLastProducts: true,
  });
};

export const trackQuickFilterApply = (filterKey: TQuickFilterKey, queryString: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Filters',
    action: 'success',
    label: QuickFiltersMap[filterKey],
    useLastProducts: true,
    page: {
      extra: {
        query_string: queryString,
        auto_apply: !['advancedFilters', 'region', 'district', 'metro'].includes(filterKey),
      },
    },
  });
};
